import {combineReducers} from 'redux';
import { productReducers, selectProductReducers, addtoCardReducers, setCategProductReducers, handleCart} from './productReducers';

export const rootReducer = combineReducers({
    touslesProduits: productReducers,
    ProduitDetail: selectProductReducers,
    PrduitsDeCart: addtoCardReducers,
    lesCategProduits: setCategProductReducers,
    // handleCart,
})